"use strict";
var distill;
(function (distill) {
    var datasets;
    (function (datasets) {
        var views;
        (function (views) {
            var createWizard3_schema;
            (function (createWizard3_schema) {
                let DatasetCreationMethod;
                (function (DatasetCreationMethod) {
                    DatasetCreationMethod["None"] = "None";
                    DatasetCreationMethod["Manual"] = "Manual";
                    DatasetCreationMethod["FormScreen"] = "FormScreen";
                    DatasetCreationMethod["DataSource"] = "DataSource";
                    DatasetCreationMethod["FileUpload"] = "FileUpload";
                })(DatasetCreationMethod || (DatasetCreationMethod = {}));
                class InitArgs {
                    constructor() {
                        this.wizardToken = '';
                        this.creationMethod = DatasetCreationMethod.None;
                        this.name = '';
                        this.externalId = '';
                        this.columns = [];
                        this.columnTypes = [];
                    }
                }
                let _initArgs;
                let _flatColumnBuilder = null;
                function init(args) {
                    _initArgs = args;
                    distill.datasets.views.setColumnTypes(_initArgs.columnTypes);
                    $(function () {
                        bindEvents();
                        initFlatBuilder(_initArgs.columns);
                    });
                }
                createWizard3_schema.init = init;
                function getParentButton(selector) {
                    return $(parent.document).find(selector);
                }
                function bindEvents() {
                    getParentButton('#wizardBackBtn').on('click', function (e) {
                        e.preventDefault();
                        history.back();
                    });
                    getParentButton('#wizardCreateBtn').on('click', function () {
                        if (validateForm())
                            submitForm();
                    });
                    $('#addColumnBtn').on('click', function () {
                        if (_flatColumnBuilder)
                            _flatColumnBuilder.addColumn();
                        appn.iframe.setModalIframeHeight(true);
                    });
                }
                function initFlatBuilder(columns) {
                    const isCruxSource = _initArgs.creationMethod === DatasetCreationMethod.FormScreen || _initArgs.creationMethod === DatasetCreationMethod.DataSource;
                    _flatColumnBuilder = new distill.datasets.views.ColumnBuilder(columns, {
                        isCruxSource: isCruxSource,
                        isCreateMode: true,
                        containerId: 'schemaColumnsList',
                        showPk: !isCruxSource,
                        showType: true,
                        showRequired: !isCruxSource,
                        showUnique: !isCruxSource,
                        allowTypeChanges: !isCruxSource,
                        onChanged: () => distill.datasets.views.ColumnBuilder.refreshIndexes([{ builder: _flatColumnBuilder }])
                    });
                    distill.datasets.views.ColumnBuilder.refreshIndexes([{ builder: _flatColumnBuilder }]);
                }
                function validateForm() {
                    var _a, _b;
                    let isValid = true;
                    $('[data-valmsg-for]').text('').addClass('field-validation-valid').removeClass('field-validation-error');
                    distill.datasets.views.ColumnBuilder.refreshIndexes([{ builder: _flatColumnBuilder }]);
                    const name = ((_b = (_a = $('input[name="Name"]').val()) === null || _a === void 0 ? void 0 : _a.toString()) === null || _b === void 0 ? void 0 : _b.trim()) || '';
                    if (!name) {
                        $('[data-valmsg-for="Name"]').text(T('Dataset name is required.')).addClass('field-validation-error').removeClass('field-validation-valid');
                        isValid = false;
                    }
                    if (!$('form').valid())
                        isValid = false;
                    if (!isValid) {
                        const $firstError = $('.field-validation-error:visible').first();
                        if ($firstError.length)
                            $firstError[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
                    }
                    return isValid;
                }
                function submitForm() {
                    distill.datasets.views.ColumnBuilder.refreshIndexes([{ builder: _flatColumnBuilder }]);
                    $('form')[0].submit();
                }
            })(createWizard3_schema = views.createWizard3_schema || (views.createWizard3_schema = {}));
        })(views = datasets.views || (datasets.views = {}));
    })(datasets = distill.datasets || (distill.datasets = {}));
})(distill || (distill = {}));
